window.addEventListener('load', function () {
    const canvi = document.querySelectorAll('.spotlight-animation-effect-canvas');
    for (let canvas of canvi) {
        setCanvasSize(); // set canvas size on load
        const ctx = canvas.getContext('2d');
        let circles = []; // Array to store circle objects
        const minSize = 20; // Minimum size of circles
        const maxSize = 90; // Maximum size of circles
        const minOpacity = 0; // Minimum opacity
        const maxOpacity = 0.2; // Maximum opacity
        const minBlur = 0; // Minimum blur
        const maxBlur = 50; // Maximum blur
        const transitionDuration = 10000; // Transition duration in milliseconds (10 seconds)
        const minGradientEnd = 0.01; // Minimum gradient end position
        const maxGradientEnd = 0.99; // Maximum gradient end position

        // to disable mouse interaction set mouseInteractionEnabled = 0
        const mouseInteractionEnabled = 1;
        const interactionDiameter = 20; // Diameter for mouse reflection interaction in pixels
        let mousePosition = { x: -1, y: -1 }; // Current mouse position
        let lastMousePosition = { x: -1, y: -1 }; // Last mouse position for calculating velocity
        let mouseVelocity = { x: 0, y: 0 }; // Mouse velocity vector
        let lastMouseMoveTime = 0; // Track the last time the mouse moved

        // Determine circleCount based on screen width - max of 100
        let circleCount = canvas.dataset.circles || Math.round(window.innerWidth / 100) * 5; // Default to screen width / 100 * 5 if dataset not available
        if (circleCount > 100) {
            circleCount = 100;
        }

        // Determine speed based on screen width
        let speed = .4; // Constant speed
        const screenWidth = window.innerWidth;

        if (screenWidth < 768) {
            speed = .25;
        } else if (screenWidth >= 768 && screenWidth < 1280) {
            speed = .375;
        }

        if (mouseInteractionEnabled) {
            document.body.addEventListener('mousemove', function(event) {
                const rect = canvas.getBoundingClientRect();
                // Update last position to the previous current position
                lastMousePosition.x = mousePosition.x;
                lastMousePosition.y = mousePosition.y;
                // Update current position
                mousePosition.x = event.clientX - rect.left;
                mousePosition.y = event.clientY - rect.top;
                // Calculate velocity
                mouseVelocity.x = mousePosition.x - lastMousePosition.x;
                mouseVelocity.y = mousePosition.y - lastMousePosition.y;
                lastMouseMoveTime = Date.now(); // Update last move time on mouse move
            });
        }

        // Function to generate random values for circle properties
        function generateRandomCircle() {
            const width = minSize + Math.random() * (maxSize - minSize); // Random width
            // Random gradient end position between 20% to 90% of the circle's width
            const gradientEndPosition = minGradientEnd + Math.random() * (maxGradientEnd - minGradientEnd);

            return {
                x: Math.random() * canvas.width, // Random x-coordinate
                y: Math.random() * canvas.height, // Random y-coordinate
                width: width, // Random width
                height: width, // Height equal to width for a perfect circle
                opacity: minOpacity + Math.random() * (maxOpacity - minOpacity), // Random opacity
                shadowBlur: minBlur + Math.random() * (maxBlur - minBlur), // Random blur
                speed: speed, // Constant speed
                originalSpeed: speed, // Original speed
                direction: Math.random() * 2 * Math.PI, // Random direction in radians
                targetWidth: width, // Initial target width same as initial width
                targetHeight: width, // Initial target height same as initial width
                targetOpacity: minOpacity + Math.random() * (maxOpacity - minOpacity), // Random target opacity
                targetShadowBlur: minBlur + Math.random() * (maxBlur - minBlur), // Random target blur
                gradientEndPosition: gradientEndPosition,
                targetGradientEndPosition: gradientEndPosition, // Initial target same as initial position
                transitionStartTime: Date.now(), // Start transition immediately
                throttleTime: 1000, // Base throttle time in ms
                baseThrottleTime: 1000, // Keep track of the base throttle time
                nextInteractionTime: Date.now(), // Allows immediate first interaction
            };
        }

        // Generate initial circles with appropriately scaled positions and sizes
        function generateInitialCircles() {
            const initialWidth = canvas.width;
            const initialHeight = canvas.height;
            circles = [];
            for (let i = 0; i < circleCount; i++) {
                const circle = generateRandomCircle();
                // Scale initial circle position and size based on canvas size
                circle.x *= canvas.width / initialWidth;
                circle.y *= canvas.height / initialHeight;
                circle.width *= canvas.width / initialWidth;
                circle.height = circle.width; // Maintain aspect ratio
                circles.push(circle);
            }
        }
        generateInitialCircles();

        function updateCircles() {
            // Clear the canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            const currentTime = Date.now();

            // If the mouse hasn't moved for 500ms, set the velocity to 0
            if (currentTime - lastMouseMoveTime > 500) {
                mouseVelocity.x = 0;
                mouseVelocity.y = 0;
            }

            // Update and draw each circle
            for (let circle of circles) {
                // Calculate transition progress for width, height, and opacity
                const progress = Math.min(1, (Date.now() - circle.transitionStartTime) / transitionDuration);
                const width = circle.width + (circle.targetWidth - circle.width) * progress;
                const height = circle.height + (circle.targetHeight - circle.height) * progress;
                const opacity = circle.opacity + (circle.targetOpacity - circle.opacity) * progress;
                const shadowBlur = circle.shadowBlur + (circle.targetShadowBlur - circle.shadowBlur) * progress;
                const gradientEndPosition = circle.gradientEndPosition + (circle.targetGradientEndPosition - circle.gradientEndPosition) * progress;

                // Calculate new position based on direction and speed
                const newX = circle.x + Math.cos(circle.direction) * circle.speed;
                const newY = circle.y + Math.sin(circle.direction) * circle.speed;

                if (mouseInteractionEnabled) {
                    // Calculate distance to mouse for each circle
                    const radius = circle.width / 2; // Assuming 'width' represents the diameter
                    const distanceToMouse = Math.sqrt(Math.pow(circle.x - mousePosition.x, 2) + Math.pow(circle.y - mousePosition.y, 2)) - radius;

                    const timeUntilNextInteraction = circle.nextInteractionTime - currentTime;

                    // Determine if interaction is allowed based on throttling and proximity
                    if (distanceToMouse <= interactionDiameter / 2) {
                        if (timeUntilNextInteraction <= 0) {
                            circle.nextInteractionTime = currentTime + circle.throttleTime; // Update next eligible interaction time

                            // Double throttle time for the next interaction, up to a limit (e.g., 4000ms)
                            circle.throttleTime = Math.min(circle.throttleTime * 2, 4000);

                            if (mouseVelocity.x !== 0 || mouseVelocity.y !== 0) {
                                // Mouse is moving, bounce the circle in the direction of mouse movement
                                circle.direction = Math.atan2(mouseVelocity.y, mouseVelocity.x);
                            } else {
                                // Mouse is stationary, calculate reflection based on incident angle
                                // Find the angle from the circle to the mouse
                                const angleToMouse = Math.atan2(mousePosition.y - circle.y, mousePosition.x - circle.x);
                                // Reflect the circle's direction across the line connecting the circle and the mouse
                                // This simulates a bounce off a surface perpendicular to the line from circle to mouse
                                let incidentAngle = circle.direction - angleToMouse;
                                circle.direction = angleToMouse - incidentAngle + Math.PI;
                            }

                            // Adjust circle speed based on mouse speed and a multiplier
                            const interactionSpeed = Math.sqrt(mouseVelocity.x ** 2 + mouseVelocity.y ** 2);
                            const velocityMultiplier = 0.05; // Adjust this to control the reflection speed
                            circle.speed = interactionSpeed > 0 ? interactionSpeed * velocityMultiplier : circle.originalSpeed;
                            circle.adjustSpeedStartTime = currentTime;

                            circle.direction = (circle.direction + 2 * Math.PI) % (2 * Math.PI); // Normalize direction
                        }
                    } else if (distanceToMouse > interactionDiameter / 2 && circle.throttleTime > circle.baseThrottleTime) {
                        // Circle is outside the interaction diameter; reset throttle time
                        circle.throttleTime = circle.baseThrottleTime;
                    }

                    // Gradually return the circle's speed to its original speed over 10 seconds
                    if (circle.adjustSpeedStartTime) {
                        const speedAdjustProgress = Math.min(1, (currentTime - circle.adjustSpeedStartTime) / 10000);
                        circle.speed = circle.originalSpeed + (circle.speed - circle.originalSpeed) * (1 - speedAdjustProgress);

                        if (speedAdjustProgress >= 1) {
                            circle.speed = circle.originalSpeed; // Reset to original speed
                            delete circle.adjustSpeedStartTime;
                        }
                    }
                }

                // Check if the new position is within the viewport bounds
                if (newX > 0 && newX < canvas.width && newY > 0 && newY < canvas.height) {
                    // Update circle position
                    circle.x = newX;
                    circle.y = newY;
                } else {
                    if (newX < 0 || newX > canvas.width) {
                        // Reflect the direction horizontally if it hits left or right edges
                        circle.direction = Math.PI - circle.direction;
                    }
                    if (newY < 0 || newY > canvas.height) {
                        // Reflect the direction vertically if it hits top or bottom edges
                        circle.direction = -circle.direction;
                    }

                    // Normalize the direction to ensure it's between 0 and 2*Math.PI
                    circle.direction = (circle.direction + 2 * Math.PI) % (2 * Math.PI);
                }

                // Draw the circle with individual opacity
                ctx.shadowColor = `rgba(88, 255, 0, 1)`; // Black shadow for maximum contrast
                ctx.shadowBlur = shadowBlur;

                // Creating the radial gradient
                const radius = width / 2; // Assuming width = circle's diameter
                const gradient = ctx.createRadialGradient(circle.x, circle.y, 0, circle.x, circle.y, radius);

                // Adjusting gradient color stops
                gradient.addColorStop(0, `rgba(88, 255, 0, ${opacity})`);
                gradient.addColorStop(gradientEndPosition, `rgba(88, 255, 0, ${opacity})`);
                gradient.addColorStop(1, 'rgba(88, 255, 0, 0)'); // Transition to complete transparency

                ctx.fillStyle = gradient;
                ctx.beginPath();
                ctx.ellipse(circle.x, circle.y, radius, radius, 0, 0, 2 * Math.PI);
                ctx.fill();

                // Check if transition is complete
                if (progress === 1) {
                    // Update target values for smooth transition
                    circle.width = circle.targetWidth;
                    circle.height = circle.targetHeight;
                    circle.opacity = circle.targetOpacity;
                    circle.shadowBlur = circle.targetShadowBlur;
                    circle.gradientEndPosition = circle.targetGradientEndPosition;
                    // Generate new random target values
                    circle.targetGradientEndPosition = 0.2 + Math.random() * 0.7; // New random target for gradient end position
                    circle.targetWidth = minSize + Math.random() * (maxSize - minSize);
                    circle.targetHeight = circle.targetWidth;
                    circle.targetOpacity = minOpacity + Math.random() * (maxOpacity - minOpacity);
                    circle.targetShadowBlur = minBlur + Math.random() * (maxBlur - minBlur);
                    circle.transitionStartTime = Date.now();
                }
            }

            // Schedule the next update
            requestAnimationFrame(updateCircles);
        }

        // Start the animation loop
        updateCircles();

        // Resize canvas when window is resized
        window.addEventListener('resize', resizeCanvas);

        function setCanvasSize() {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        }

        function resizeCanvas() {
            const oldWidth = canvas.width;
            const oldHeight = canvas.height;
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            // Scale circle positions and sizes based on the new canvas size
            for (let circle of circles) {
                circle.x = (circle.x / oldWidth) * canvas.width;
                circle.y = (circle.y / oldHeight) * canvas.height;
                circle.width = (circle.width / oldWidth) * canvas.width;
                circle.height = circle.width; // Maintain aspect ratio
            }
        }
    }
});
